import { createContext } from "react";

export interface ActivitiesDataContextValue {
}

export const ActivitiesDataContext = createContext<ActivitiesDataContextValue | null>(null);

export function ActivitiesDataProvider({ children }: { children: React.ReactNode }) {

  return (
    <ActivitiesDataContext.Provider
      value={{}}
    >
      {children}
    </ActivitiesDataContext.Provider>
  );
}